import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from '../dialog';
import { AffecteCycleELModel, Chapter, ChapterTarification, CycleEL, ePriceType, QResult, QueovalDate, QueovalDateTime, UserEL } from '../models';
import { DateRequiredBoProperty } from '../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { Item } from '../models/payment';
import { CoreService, HttpService, QueovalDateService } from '../services';
import { PaymentStripeService } from '../services/paymentStripe.service';
import { ToastService } from '../toast';


@Component({
  selector: 'q-affecte-cycleel',
  templateUrl: './affecte-cycleel.component.html',
  styleUrls: ['./affecte-cycleel.component.css']
})
export class AffecteCycleELComponent implements OnInit {

  public idLearner: string = '0';


  /**
   * Modèle de l'utilisateur E-Learning
   */
  public user: UserEL;
  /**
   * Liste des cycles E-Learning
   */
  public listCycleEL: CycleEL[];
  /**
   * Liste des cycles E-Learning filtrés
   */
  /* public listCycleELFilter: CycleEL[];*/
  /**
   * Filtre
   */
  public filter: string;

  /**
   * Date d'expiration pour l'apprenant
   */
  public dateExpiration: QueovalDate;

  /**
   * Booléen pour le chargement des chapitres
   */
  public chapterLoading: boolean;

  /**
   * Booléen pour afficher ou non le block de paiement
   */
  public showPayment: boolean;

  /**
   * Booléen pour le chargement du paiement
   */
  public showLoaderPayment: boolean;

  /**
   * Booléen pour le chargement de l'insertion d'un chapitre auteur dans la liste des disponibles
   */
  public showLoaderPushAut: boolean;

  /**
   * Listes des chapitres
   */
  public listChaptersEL: Array<Chapter>;
  public listChaptersAutOK: Array<Chapter>;
  public listChaptersAutAvailable: Array<Chapter>;

  public stripeIsActive: boolean;

  // Mode pour le payment
  public mode: string = "AUTHORCHAPTER";
  public items: Array<Item> = new Array<Item>;

  @ViewChild('chapELContainer') chapELContainer: ElementRef;
  @ViewChild('chapAutOkContainer') chapAutOkContainer: ElementRef;
  @ViewChild('chapAutAvailableContainer') chapAutAvailableContainer: ElementRef;

  /**
  * Ident de l'apprenant
  */
  @Input('idLearner') set SetId(value: string) {
    if (value)
      this.idLearner = value;
    this.initData();
  }

  /**
   * Pour envoyer le modèle au composant père
   */
  @Output() sendEvent: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Output permettant au composant parent de récupérer la date d'expiration'
   */
  @Output() updateValueDateExp: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    protected activatedRouter: ActivatedRoute,
    protected indParam: CoreService,
    protected http: HttpService,
    protected render: Renderer2,
    protected dialogservice: DialogService,
    protected toastservice: ToastService,
    protected qDateService: QueovalDateService,
    private renderer: Renderer2,
    public paymentStripeService: PaymentStripeService
  ) { }

  /**
  * Initialisation du composant
  */
  ngOnInit(): void {
    this.showPayment = false;
  }

  // #region Public functions
  /**
   * Filtre sur la liste des cycles - Retiré...
   */
  //filterCycleELList(): void {
  //  this.listCycleELFilter = new Array<CycleEL>();
  //  this.listCycleEL.forEach((cyc: CycleEL) => {
  //    if (cyc.Name.toUpperCase().includes(this.filter.toUpperCase())) {
  //      this.listCycleELFilter.push(cyc);
  //    }
  //  });
  //}

  /**
   * Décoche tous les cycles
   */
  uncheckAll(): void {
    this.listCycleEL.forEach((cyc: CycleEL) => {
      cyc.IsChecked = false;
    });
    // Récupération de la liste des chaitre pour vider les groupes
    this.getChapters();
  }

  /**
   * Ajout des cycles à l'utilisateur
   */
  addCycleELToUser(): void {

    this.dialogservice.showSplash(true);
    const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
    affecteCycleModel.ListAllCycles = this.listCycleEL;
    affecteCycleModel.UserSelected = this.user;
    this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/ADD_CYCLES_TO_USER`, affecteCycleModel).subscribe(
      (data: QResult<AffecteCycleELModel>) => {
        if (!data.HasError) {
          this.toastservice.showSuccessToast(`${this.indParam.getTrad('Cyclesassignedto_EL')} ${this.user.FirstName} ${this.user.Name}`);

          // Fermeture de la modale
          this.sendEvent.emit(true);
          this.dialogservice.showSplash(false);
        } else {
          this.dialogservice.showSplash(false);
          this.dialogservice.showAlert(`${this.indParam.getTrad('Erroraddingcycles_EL')} : ${data.Error}`);
        }
      }, () => {
      });

  }


  /**
  * Enregistrement de la date d'expiration du digital Learning
   */
  SaveDateExpiration(): void {
    if (this.IsDateExpirationNull()) {
      this.toastservice.showWarningToast(`Merci de renseigner une date valide`);
    }
    else {
      this.dialogservice.showSplash(true);
      this.user.DateExpEL = this.dateExpiration;
      const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
      affecteCycleModel.UserSelected = this.user;
      this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/SAVE_DATE_EXPIRATION`, affecteCycleModel).subscribe(
        (data: QResult<AffecteCycleELModel>) => {
          if (!data.HasError) {
            this.toastservice.showSuccessToast(`${this.indParam.getTrad('TheExpirationDateHasBeenSaved')}`);
            this.updateValueDateExp.emit(this.qDateService.ToString(this.dateExpiration));

            this.dialogservice.showSplash(false);
          } else {
            this.dialogservice.showSplash(false);
            this.dialogservice.showAlert(`${this.indParam.getTrad('ErrorInRecordingTheExpirationDate')} : ${data.Error}`);
          }
        }, () => {
        });
    }

  }

  /**
  * Enregistrement de la date d'expiration du digital Learning
   */
  DeleteDateExpiration(): void {
    this.dialogservice.showSplash(true);
    const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
    affecteCycleModel.UserSelected = this.user;
    this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/DELETE_DATE_EXPIRATION`, affecteCycleModel).subscribe(
      (data: QResult<AffecteCycleELModel>) => {
        if (!data.HasError) {
          this.toastservice.showSuccessToast(`La date d'expiration a bien été supprimée`);
          this.dateExpiration = new QueovalDate();
          this.updateValueDateExp.emit(this.qDateService.ToString(this.dateExpiration));

          this.dialogservice.showSplash(false);
        } else {
          this.dialogservice.showSplash(false);
          this.dialogservice.showAlert(`Erreur dans la suppression de la date d'expiration : ${data.Error}`);
        }
      }, () => {
      });

  }

  /**
   * Chargement des chapitres
   */
  public getChapters(): void {
    // remise à zéro du paiement
    this.showPayment = false;
    this.chapterLoading = true;
    const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
    affecteCycleModel.UserSelected = this.user;
    affecteCycleModel.ListAllCycles = this.listCycleEL;
    this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/LOAD_CHAPTERS_LIST`, affecteCycleModel).subscribe(
      (data: QResult<AffecteCycleELModel>) => {
        if (!data.HasError) {
          this.listChaptersEL = data.Value.ListChaptersEL;
          this.listChaptersAutOK = data.Value.ListChaptersAutOk;
          this.listChaptersAutAvailable = data.Value.ListChaptersAutAvailable;
          this.stripeIsActive = data.Value.StripeIsActif;
          this.chapterLoading = false;
        } else {
          this.chapterLoading = false;
        }
      }, () => {
      });
  }

  /**
   * Ouverture / Fermeture d'un block contenant des chapitres
   * @param event
   * @param codeList
   */
  expendList(event: any, codeList: string) {

    let element: any = null;

    switch (codeList) {
      case 'EL':
        element = this.chapELContainer.nativeElement;
        break;
      case 'AUTOK':
        element = this.chapAutOkContainer.nativeElement;
        break;
      case 'AUTAVAILABLE':
        element = this.chapAutAvailableContainer.nativeElement;
        break;
      default:
        break;
    }

    // element = event.currentTarget;
    if (element) {
      if (element.classList.contains('list-closed')) {
        this.renderer.removeClass(element, 'd-none');
        this.renderer.removeClass(element, 'list-closed');
        this.renderer.addClass(element, 'list-expanded');
        this.renderer.setStyle(element, 'max-height', `${element.scrollHeight}px`);
        this.renderer.removeClass(event.currentTarget.querySelector('i'), 'fa-chevron-down');
        this.renderer.addClass(event.currentTarget.querySelector('i'), 'fa-chevron-up');

      } else {
        this.renderer.addClass(element, 'list-closed');
        this.renderer.removeClass(element, 'list-expanded');
        this.renderer.setStyle(element, 'max-height', `0`);
        this.renderer.removeClass(event.currentTarget.querySelector('i'), 'fa-chevron-up');
        this.renderer.addClass(event.currentTarget.querySelector('i'), 'fa-chevron-down');
        setTimeout(() => {
          this.renderer.addClass(element, 'd-none');
        }, 200);

      }
    }

  }

  /**
   * Retourne la classe pour le style de la date d'expiration
   * @param expirationDate
   * @returns
   */
  getClassDate(expirationDate: QueovalDateTime): string {
    // Pas de date d'expi
    if (expirationDate && expirationDate.annee != '0') {
      if (this.qDateService.Compare(expirationDate, '<=', this.qDateService.Now())) {
        return 'q-danger';
      }
      if (this.qDateService.Compare(expirationDate, '>', this.user.DateExpEL)) {
        return 'q-warning';
      }
      else {
        return 'q-success';
      }

    }
    return '';
  }

  /**
  * met à jour la date d'expiration d'un chapitre pour un apprenant
  * @param date nouvelle date
  * @param chapter chapitre sur lequel on modifie la date
  */
  public UpdateDate(date: DateRequiredBoProperty, chapter: Chapter): void {

    const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
    affecteCycleModel.UserSelected = this.user;
    if (date.Value) {
      chapter.ExpirationDate.Value = date.Value;

      // Si la date d'expiration est < Now ALORS on prend Now comme date d'expiration du chapitre
      if (this.qDateService.Compare(chapter.ExpirationDate.Value, '<', this.qDateService.Now()) && !this.qDateService.Compare(chapter.ExpirationDate.Value, '>', this.user.DateExpEL)) {
        let qDateNow = this.qDateService.Now();
        chapter.ExpirationDate.Value = new QueovalDateTime(qDateNow.annee, qDateNow.mois, qDateNow.jour);
        this.toastservice.showInfoToast(`${this.indParam.getTrad('ThisChapterExpiresToday')}`);
      }

      // Si la date d'expiration du chapitre est > date d'expiration de DL de l'apprenant ALORS on prend la date d'expiration du DL
      if (this.qDateService.Compare(chapter.ExpirationDate.Value, '>', this.user.DateExpEL)) {
        chapter.ExpirationDate.Value = new QueovalDateTime(this.user.DateExpEL.annee, this.user.DateExpEL.mois, this.user.DateExpEL.jour);
        this.toastservice.showInfoToast(`${this.indParam.getTrad('ThisChapterWillExpiresAtTheEnd')}`);
      }

    }
    else {
      chapter.ExpirationDate.Value = new QueovalDateTime();
    }

    affecteCycleModel.ChapterSelected = chapter;

    this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/SAVE_DATEEXP_CHAPTER`, affecteCycleModel).subscribe();
  }

  /**
   * Retourne la date d'expiration d'un chapitre auteur en fonction de la tarification du chapitre
   * @param chapter
   * @returns
   */
  public GetDateExpirationChapES(chapter: Chapter): QueovalDate {
    if (chapter.ExpirationDate.Value) {
      let date = this.qDateService.ToDateTime(chapter.ExpirationDate.Value);
      // Si mode mois -> ajout de la quantité en mois
      if (chapter.Tarification.Type == ePriceType.MONTH) {
        date?.setMonth(date.getMonth() + chapter.Tarification.Quantite);
      }
      // Si mode année -> ajout de la quantité en année
      if (chapter.Tarification.Type == ePriceType.YEAR) {
        date?.setFullYear(date.getFullYear() + chapter.Tarification.Quantite);
      }

      // chapter.ExpirationDate.Value = this.qDateService.FromDateTime(date);
      return this.qDateService.FromDateTime(date);
    }
    else {
      let date = new Date(Date.now());
      // chapter.ExpirationDate.Value = this.qDateService.FromDateTime(date);
      return this.qDateService.FromDateTime(date);
    }

  }

  /**
   * Retourne le montant total à payer en fonction des quantités choisies
   * @returns
   */
  public GetMontantTotalChapES(): number {
    let total = 0;
    this.listChaptersAutAvailable.forEach((chap: Chapter) => {
      total += chap.Tarification.Montant * chap.Tarification.Quantite;
    });
    this.paymentStripeService.paymentAmount = total;
    return total;
  }

  /**
   * Retourne le nombre total de quantités choisies
   * @returns
   */
  public GetNbTotalChapES(): number {
    let total = 0;
    this.listChaptersAutAvailable.forEach((chap: Chapter) => {
      total += chap.Tarification.Quantite;
    });
    return total;
  }

  public GetMontantSelected(chapter: Chapter): number {
    return chapter.Tarification.Quantite * chapter.Tarification.Montant;
  }

  /**
   * Pousse le chapitre auteur dans la liste des chapitres "disponibles"
   * @param chapter
   */
  public PushChapAut(chapter: Chapter): void {
    this.showLoaderPushAut = true;
    // si le chapitre est déjà dans la liste des chapitre disponible -> on augmente la quantité
    let chapAlreadyPush = false;
    if (this.listChaptersAutAvailable.length > 0) {
      this.listChaptersAutAvailable.forEach((chap: Chapter) => {
        if (chap.Ident === chapter.Ident) {
          chap.Tarification.Quantite += 1;
          chapAlreadyPush = true;
          this.showLoaderPushAut = false;
        }
      });
    }

    if (!chapAlreadyPush) {
      // Récupération des informations de tarification pour le chapitre
      this.showLoaderPushAut = true;
      this.http.getHttp<QResult<ChapterTarification>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/GET_CHAPTER_TARIF_ESTORE/${chapter.IdentES}`).subscribe(
        (data: QResult<ChapterTarification>) => {
          this.showLoaderPushAut = false;
          if (!data.HasError) {
            // Si pas de tarification lié à ce chapitre -> on ne peut pas l'ajouter
            if (data.Value == null || data.Value.Type == null) {
              this.toastservice.showWarningToast(`${this.indParam.getTrad('ThisChapterCannotBeRenewed')} : ${this.indParam.getTrad('NoPricingAvailableInEstore')}`);
            }
            else {
              // affectation de la tarification, ajout d'une quantité et ajout dans la liste
              chapter.Tarification = data.Value;
              chapter.Tarification.Quantite = 1;
              this.listChaptersAutAvailable.push(chapter);
              this.toastservice.showSuccessToast(`${this.indParam.getTrad('ChapterAddedInTheNewAuthorChapters')}`);
              // resize du bloc si ouvert
              if (!this.chapAutAvailableContainer.nativeElement.classList.contains('list-closed')) {
                this.renderer.setStyle(this.chapAutAvailableContainer.nativeElement, 'max-height', `${this.chapAutAvailableContainer.nativeElement.scrollHeight + 50}px`);
              }
            }
          }
        });
    }

  }

  //#region paiement

  /**
   * Ouverture du paiement en ligne
   */
  public OpenPayment(): void {
    this.items = new Array<Item>;

    if (this.listChaptersAutAvailable.length > 0) {
      this.listChaptersAutAvailable.forEach((e) => {
        var paymentModel: Item = new Item()
        paymentModel.Id = e.IdentES;
        paymentModel.Quantity = e.Tarification.Quantite;
        paymentModel.Name = e.Title;
        paymentModel.Price = e.Tarification.Montant;
        this.items.push(paymentModel);
      });
    }

    this.showPayment = true;
  }

  /**
   * Fermeture du paiement en ligne
   */
  public ClosePayment(): void {
    this.showPayment = false;
  }

  public ValidPayment(): void {
    this.showLoaderPayment = true;
    const affecteCycleModel: AffecteCycleELModel = new AffecteCycleELModel;
    affecteCycleModel.UserSelected = this.user;
    affecteCycleModel.ListChaptersAutAvailable = this.listChaptersAutAvailable;

    this.http.postHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/AFFECT_CHAPTERS_AUTHOR`, affecteCycleModel).subscribe(
      (result: QResult<AffecteCycleELModel>) => {
        if (!result.HasError && !result.HasAlert) {
          this.toastservice.showSuccessToast(`${this.indParam.getTrad('TheChaptersHaveBeenAddedTTheCycleFor')} ${this.user.FirstName} ${this.user.Name} `);
          this.showPayment = false;
          this.showLoaderPayment = false;
          // Rechargement de la liste des chapitres
          this.getChapters();
        }
      });
  }

  public IsDateExpirationNull(): boolean {
    return this.qDateService.IsNull(this.dateExpiration);
  }

  //#endregion

  // #endregion
  // #region private functions
  /**
   * Récupération de la liste des cycle E-Learning
   */
  private initData(): void {
    this.chapterLoading = false;
    // Récupération des infos de l'utilisateur + ses cycles EL
    this.dialogservice.showSplash(true);
    if (this.idLearner === '') {
      this.toastservice.showAlertToast(this.indParam.getTrad('Userrecoveryerror_EL'));
    } else {
      this.http.getHttp<QResult<AffecteCycleELModel>>(`${this.indParam.AppParams.apiUrl}api/AffecteCycleEL/GET_LIST_CYCLE_EL/${this.idLearner}`).subscribe(
        (data: QResult<AffecteCycleELModel>) => {
          this.dialogservice.showSplash(false);
          if (!data.HasError) {
            this.user = data.Value.UserSelected;
            this.listCycleEL = data.Value.ListAllCycles;
            // Mise à jour des cycles de l'utilisateur dans la liste
            this.listCycleEL.forEach((cyc: CycleEL) => {
              this.user.ListCycles.forEach((c: CycleEL) => {
                if (c.Ident === cyc.Ident) {
                  cyc.IsChecked = true;
                }
              });
            });

            // Affectation de la date d'expiration à partir de celle récupérée sur l'apprenant (pour le moment)
            if (this.user) {
              this.dateExpiration = this.user.DateExpEL;
            }

            // Chargement de la liste de tous les chapitres à partir de la liste des cycles
            this.getChapters();

          }
        }, () => {
        });
    }

  }

  // #endregion
}
